module.exports = __webpack_public_path__ + "static/media/prize-tray-forward.f36b7681.png";